import { IF, RETURNER, UIComponentView, UITextView, UIView } from "uicore-ts"
import { CBEditorNestedAttributes } from "../EditorViewController"
import { SearchableDropdown } from "./SearchableDropdown"


@UIComponentView
export class LabeledSearchableDropdown<T> extends UIView {
    
    @CBEditorNestedAttributes(2)
    label: UITextView
    
    @CBEditorNestedAttributes(2)
    dropdown: SearchableDropdown<T>
    
    constructor(elementId?: string) {
        
        super(elementId)
        
        this.label = new UITextView(this.elementID + "Label", UITextView.type.header5)
        this.addSubview(this.label)
        
        this.dropdown = new SearchableDropdown(this.elementID + "Dropdown")
        this.addSubview(this.dropdown)
        
        this.dropdown.expandedContainerViewHeight = 350
        
    }
    
    get selectedItemCodes() {
        return this.dropdown.selectedItemCodes
    }
    
    set selectedItemCodes(selectedItemCodes: string[]) {
        this.dropdown.selectedItemCodes = selectedItemCodes
    }
    
    override updateContentForCurrentEnabledState() {
        
        this.userInteractionEnabled = this.enabled
        this.alpha = IF(this.enabled)(RETURNER(1)).ELSE(RETURNER(0.5))
        
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
    
        const padding = this.core.paddingLength
        const labelHeight = padding
    
        const bounds = this.bounds
    
        this.label.frame = bounds.rectangleWithHeight(labelHeight)
        
        this.dropdown.frame = bounds.rectangleWithHeight(51).rectangleWithY(labelHeight)
        
        
        //this.dropdown.expandedContainerViewHeight = this.superview.bounds.height - this.frame.max.y - padding
        
        
    }
    
    
}
















